import { render, staticRenderFns } from "./UserEditViewsList.vue?vue&type=template&id=43dd8e12"
import script from "./UserEditViewsList.vue?vue&type=script&lang=ts"
export * from "./UserEditViewsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43dd8e12')) {
      api.createRecord('43dd8e12', component.options)
    } else {
      api.reload('43dd8e12', component.options)
    }
    module.hot.accept("./UserEditViewsList.vue?vue&type=template&id=43dd8e12", function () {
      api.rerender('43dd8e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/UserEditViewsList.vue"
export default component.exports